export const setSectionPath = (sectionPath) =>{
  sessionStorage.setItem('sectionPath',sectionPath)
}
export const getSectionPath = ():string =>{
  return sessionStorage.getItem('sectionPath')
}
export const removeSectionPath = () =>{
  sessionStorage.removeItem('sectionPath')
}
